import styled from "styled-components";
import { antd_breakingPts } from "src/utils/constants/media";
import { colors } from "src/theme/colors";
import { line, radii, shadow, space } from "src/theme/ui";

export const Container = styled.div`
  position: fixed;
  right: ${space.lg}px;
  bottom: 5rem;
  z-index: 999;

  [data-display="show"] {
    div {
      display: block;
    }
  }

  @media (min-width: ${antd_breakingPts.lg}px) {
    display: none;
  }
`;

export const DropDownBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: ${radii.lg}px;
  background-color: ${colors.gray[900]};
  box-shadow: ${shadow.raised};
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    box-shadow: ${shadow.overlay};
  }
  &:active {
    transform: translateY(1px);
  }

  & img {
    width: 1rem;
    aspect-ratio: 1/1;
  }
`;

export const DropDownContainer = styled.div`
  position: absolute;
  top: 0;
  right: 3.25rem;
  padding-right: ${space.sm}px;
`;

export const DropDownContent = styled.div`
  display: none;
  min-width: 10rem;
  padding: ${space.md}px ${space.md}px ${space.xs}px;
  background-color: ${colors.white};
  border: 1px solid ${line.hairline};
  border-radius: ${radii.lg}px;
  box-shadow: ${shadow.overlay};
`;

export const Content = styled.a`
  display: flex;
  align-items: center;
  padding: ${space.sm}px;
  margin-bottom: ${space.xs}px;
  border-radius: ${radii.md}px;
  color: ${colors.gray[700]};
  font-size: 13px;
  font-weight: 500;
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: ${colors.gray[50]};
    color: ${colors.primary[600]};
  }

  & img {
    width: 1rem;
    aspect-ratio: 1/1;
    margin-right: ${space.sm}px;
  }
`;
